import router from '@/router'
export const goToSupplierMaintenance401 = () => {
  router.push({
    path: '/supplierMaintenance/401'
  })
}
